import React, {useState} from 'react';
import {ReactFieldBase as FieldBase} from 'dynamic-data-mapping-form-field-type';
import {useSyncValue} from "./UseSyncValue";


const VsFormQuittance = ({name, onChange, predefinedValue, readOnly, value}) =>
	<>
		<div className="div-quitance" id="div-quittance" >
			<input
				className="ddm-field-vs-form-quittance form-control vs-form-quittance"
				disabled={readOnly}
				name={name}
				onInput={onChange}
				type="text"
				value={value ? value : predefinedValue}/>
		</div>
	</>
const Main = ({label, name, onChange, predefinedValue, readOnly, value, ...otherProps}) => {
	const [isChecked, setIsChecked] = useState(false);
	const [currentValue, setCurrentValue] = useSyncValue(
		value ? value : otherProps.userEmail
	);

	const handleCheckboxChange = () => {
		setIsChecked(!isChecked);
	};

	return (
		<div>
			<label htmlFor="{$name}-cb">
				<input type="checkbox" id="cbQuittanceChanged" name="cbQuittanceChanged"
					   onClick={handleCheckboxChange}
					   value="send"/>
				&nbsp;{Liferay.Language.get('cb.label')}
			</label>

			{isChecked && (
			<FieldBase
				label={label}
				name={name}
				predefinedValue={predefinedValue}
				{...otherProps}
			>
				<VsFormQuittance
					name={name}
					onChange={(event) => {
						setCurrentValue(event.target.value);
						onChange(event);
					}}
					predefinedValue={predefinedValue}
					readOnly={readOnly}
					value={currentValue}
				/>
			</FieldBase>
			)}
		</div>
	);
}

Main.displayName = 'VsFormQuittance';

export default Main;


